import Spinner from 'components/shared/app/Spinner';
import { ErrorMessages } from 'lib/AppErrors';
import Config from 'lib/Config';
import Button from 'components/shared/app/Button';
import Logo from 'components/shared/app/Logo';
import React, { useState } from 'react';
import Helmet from 'react-helmet';
import { Link, useParams } from 'react-router-dom';
import { ValidationUtils } from 'lib/utils/Validation';
import arrowIcon from 'static/icons/icon_arrow_blue_round.svg';
import './style.scss';

const ResetPassword = (props) => {
    const { token } = useParams();
    const inputPassword = React.createRef();
    const inputRePassword = React.createRef();
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState('');

    const submitReset = () => {
        if (inputPassword.current && inputRePassword.current) {
            const password = inputPassword.current.value;
            const rePassword = inputRePassword.current.value;

            if (!password || !rePassword) {
                return setError('Please enter your new password.');
            }
            if (password !== rePassword) {
                return setError('Please make sure your passwords match.');
            }
            if (password.length < 8) {
                return setError('Password must be at least 8 characters.');
            }
            if (!ValidationUtils.isStrongPassword(password)) {
                return setError(ErrorMessages.passwordValidationError(password));
            }

            setLoading(true);

            props.auth
                .resetPassword(token, password)
                .then((r) => {
                    setSuccess(true);
                })
                .catch((e) => {
                    setError(e.error || 'An error occurred.');
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    };

    const onKeyUp = async (e) => {
        if (e.keyCode == 13) {
            submitReset();
        }
    };

    return (
        <div className="reset-container center flex-col-center-both col-single pad-default">
            <Helmet>
                <title>Welcome to {Config.SITE_TITLE_PREFIX}</title>
            </Helmet>
            <div className="logo">
                <Logo symbol />
            </div>
            <div className="reset-content">
                {success ? (
                    <div className="success">
                        <p>Your password has been successfully reset!</p>

                        <Link className="btn-login" to="/login">
                            <Button
                                round
                                simple
                                bold
                                filled
                                center
                                color="white"
                                icon={<img src={arrowIcon} />}
                                iconPosition="right"
                                textPosition="center">
                                Login
                            </Button>
                        </Link>
                    </div>
                ) : (
                    <form className="reset-form">
                        <div className="input-row pad lg ns">
                            <input
                                type="password"
                                autoComplete="current-password"
                                placeholder="Password *"
                                ref={inputPassword}
                                className="input simple"
                                onKeyUp={onKeyUp}
                            />
                        </div>
                        <div className="input-row pad lg ns">
                            <input
                                type="password"
                                autoComplete="current-password"
                                placeholder="Re-Enter Password *"
                                ref={inputRePassword}
                                className="input simple"
                                onKeyUp={onKeyUp}
                            />
                        </div>
                        <div className="button-row pad lg ns">
                            <Button
                                round
                                simple
                                bold
                                filled
                                center
                                color="white"
                                icon={loading ? <Spinner size="small fit" className="icon" color="blue" /> : <img src={arrowIcon} />}
                                iconPosition="right"
                                textPosition="center"
                                onClick={e => submitReset()}>
                                Continue
                            </Button>
                        </div>
                        {error && <div className="error pad sm">{error}</div>}
                    </form>
                )}
            </div>
        </div>
    );
};

export default ResetPassword;
